import { Breed, Breeder, BreederPet } from 'shared/@generated/models';
import { createZustandContext } from 'shared/state/create-zustand-context';
import { createStore } from 'zustand/vanilla';

interface BreederState {
  breeder: Breeder | null;
  breeds: Breed[];
  breederPets: BreederPet[];

  reset: () => void;
  updateBreeder: (data: Partial<Breeder>) => void;
  addBreed: (breed: Breed) => void;
  removeBreed: (breed: Breed) => void;
  addBreederPet: (breederPet: BreederPet) => void;
  updateBreederPet: (breederPet: BreederPet) => void;
  removeBreederPet: (breederPet: BreederPet) => void;
}

export const [BreederProvider, useBreederStore, useBreederStoreApi] =
  createZustandContext<BreederState>((init) =>
    createStore<BreederState>()((set) => ({
      breeder: init.breeder ?? null,
      breeds: init.breeder?.breeds ?? [],
      breederPets: init.breeder?.breeder_pets ?? [],

      reset: () => {
        set({ breeder: null, breeds: [], breederPets: [] });
      },
      updateBreeder: (data: Partial<Breeder>) => {
        set((state) => ({
          breeder: state.breeder ? { ...state.breeder, ...data } : (data as Breeder),
        }));
      },
      addBreed: (breed: Breed) => {
        set((state) => ({
          breeds: [breed, ...state.breeds],
        }));
      },
      removeBreed: (breed: Breed) => {
        set((state) => ({
          breeds: state.breeds.filter((b) => b.id !== breed.id),
        }));
      },
      addBreederPet: (breederPet: BreederPet) => {
        set((state) => ({
          breederPets: [breederPet, ...state.breederPets],
        }));
      },
      updateBreederPet: (breederPet: BreederPet) => {
        set((state) => ({
          breederPets: state.breederPets.map((bp) => (bp.id === breederPet.id ? breederPet : bp)),
        }));
      },
      removeBreederPet: (breederPet: BreederPet) => {
        set((state) => ({
          breederPets: state.breederPets.filter((bp) => bp.id !== breederPet.id),
        }));
      },
    })),
  );

export default useBreederStore;
